const INTAKE_SEGMENT_ROW_SCOPE = 'intake-segment-row';

export const IntakeSegmentRowTestIds = {
  getRestoreButtonId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.restore-button-${segId}`,
  getSelectCheckboxId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.select-checkbox-${segId}`,
  getTypeSelectId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.type-select-${segId}`,
  getPreviewButtonId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.preview-button-${segId}`,
  getSplitButtonId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.split-button-${segId}`,
  getMergePrevButtonId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.merge-prev-button-${segId}`,
  getMergeNextButtonId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.merge-next-button-${segId}`,
  getRemoveButtonId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.remove-button-${segId}`,
  getReclassifyButtonId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.reclassify-button-${segId}`,
  getApplySplitButtonId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.apply-split-button-${segId}`,
  getCancelSplitButtonId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.cancel-split-button-${segId}`,
  getGroupingChipId: segId => `${INTAKE_SEGMENT_ROW_SCOPE}.grouping-chip-${segId}`,
};
